import React, {useEffect, useState} from "react";
import renderUtils from "../../helpers/renderUtils";
import {Badge} from "react-bootstrap";
import {CustomSelect} from "../../components/form/CustomSelect";
import utils from "../../helpers/utils";
import {DaysSinceLastCleaningBadge} from "../management/actions/DaysSinceLastCleaningBadge";
import {NewTabBadge} from "../../components/badge/NewTabBadge";
import { useTranslation } from 'react-i18next';


const PartInstallation = ({
                              formatPart,
                              installPart,
                              cleaningValidDuration,
                              installations,
                              parts,
                              simulation,
                              readOnly
                          }) => {

    const { t } = useTranslation();
    const [configuration, setConfiguration] = useState()

    useEffect(() => {
        setConfiguration(installations.find(installation => installation.formatPartId === formatPart.id))
    }, [installations])

    const [options, setOptions] = useState()

    useEffect(() => {
        if (parts) {
            setOptions(parts.map(part => {
                    return {
                        value: part,
                        isDisabled: simulation ? part.partStatus === "WITHDRAWN" : part.partStatus !== "STORAGE" && part.id !== configuration?.originalPart?.id,
                        label:
                            <div className={"d-flex justify-content-between"}>
                                <div className={"d-flex align-items-center"}>
                                    <Badge className={"outline-secondary font-max  mx-1 mr-1"}>{t("object_types.part")}</Badge>
                                    <Badge variant={"primary"} className={"mr-2"}>{part.id}</Badge>
                                    <Badge className={"outline-secondary font-max  mx-1"}>{t("production.part_from_format")}</Badge>
                                    <NewTabBadge tooltip={t("production.more_about_format")}
                                                 placement={"right"}
                                                 newTabUrl={"#/management/" + part.formatId}
                                                 className={"mr-1"}>{part.formatId}</NewTabBadge>
                                    {part.formatName && <Badge className={"outline-secondary font-max mr-1"}>{part.formatName}</Badge>}
                                </div>
                                <div>
                                    <DaysSinceLastCleaningBadge part={part} cleaningValidDuration={cleaningValidDuration}/>
                                    {renderUtils.renderPartStatus(part.partStatus, "", true, t)}
                                </div>
                            </div>
                    };
                })
            )
        }

    }, [parts, configuration])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const searchBy = (option) => {
        return utils.join([option.id, option.formatId])
    }

    return <>
        {

            <>
                {
                    options &&
                    <CustomSelect
                        value={options.find(option => option.value?.id === configuration?.part?.id) || null} // Handle potential undefined values
                        onChange={(selectedOption) => installPart(selectedOption?.value, formatPart.id)}
                        isDisabled={readOnly}
                        isClearable
                        placeholder={t("forms.choose")}
                        options={options}
                        searchBy={searchBy}
                    />

                }
            </>
        }
    </>;
}

export default PartInstallation;

